import { User } from '../../../../../models/User'
import { Col, Row } from 'react-bootstrap'
import React from 'react'
import { Button } from '../../../../../components/Button/Button'
import classNames from 'classnames'
import './Clients.scss'

export interface ClientProps {
  user: User
  userClicked: (user: User) => void
  isActive: boolean
}

export const Client: React.FC<ClientProps> = ({ user, userClicked, isActive }) => {
  return (
    <div>
      <Button
        className={classNames('rounded-1 py-3 zocks-px-1.25', {
          'border border-1 zocks-border-color-gray-500': !isActive,
          'border border-1 zocks-bg-color-gray-900': isActive,
        })}
        onClick={() => userClicked(user)}
      >
        <>
          <div
            className={classNames('d-flex rounded-1 p-1 client-picker justify-content-center', {
              'zocks-bg-color-gray-900': !isActive,
              'bg-white': isActive,
            })}
          >
            <i
              className={classNames('bi bi-person-fill', {
                'text-white': !isActive,
              })}
            ></i>
          </div>
          <span
            className={classNames('paragraph-medium bold', {
              'text-white': isActive,
            })}
          >
            {user.name}
          </span>
        </>
      </Button>
    </div>
  )
}

export interface ClientsProps {
  users: User[]
  userClicked: (user: User) => void
  activeClient: User
}

export const Clients: React.FC<ClientsProps> = ({ users, userClicked, activeClient }) => {
  return (
    <Row>
      <Col className='d-flex px-3 gap-2'>
        {users.map((u) => {
          return <Client key={u.id} user={u} userClicked={userClicked} isActive={u.id === activeClient.id} />
        })}
      </Col>
    </Row>
  )
}
